import BuySellPrices from './BuySellPrices';

export default BuySellPrices;
